class HorizontalWheelScroll extends HTMLElement {
  connectedCallback() {
    this.addEventListener('wheel', this.#handleWheel, { passive: false });
  }

  disconnectedCallback() {
    this.removeEventListener('wheel', this.#handleWheel);
  }

  #handleWheel = (event) => {
    if (event.ctrlKey || event.deltaY === 0) return;

    const maxScrollLeft = this.scrollWidth - this.clientWidth;
    if (maxScrollLeft <= 0) return;

    const multiplier = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? this.clientWidth : 1;
    const delta = event.deltaY * multiplier;
    const atStart = this.scrollLeft <= 0;
    const atEnd = this.scrollLeft >= maxScrollLeft - 1;

    if ((delta < 0 && atStart) || (delta > 0 && atEnd)) return;

    event.preventDefault();
    this.scrollLeft = Math.max(0, Math.min(maxScrollLeft, this.scrollLeft + delta));
  };
}

if (!customElements.get('horizontal-wheel-scroll')) {
  customElements.define('horizontal-wheel-scroll', HorizontalWheelScroll);
}
